<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11.5" stroke="#000"/>
  <path fill="#000" d="M12.75 14.5h-1.5V7h1.5v7.5zM12.75 17h-1.5v-1.5h1.5V17z"/>
</svg>
